/**
 * AnchorInteractiveHandler — branche t="i" de Anchor + dispatch action générique (ha/448).
 *
 * Fetch async via `dataRepo.fetchData` puis route la réponse, qui peut elle-même
 * embarquer un `todo` étendu (reload/success/app/url/dom/bulk/steps/default).
 * Aucun changement de comportement (extrait littéralement de Anchor.processInteractive
 * + processAction + processBulkAction + updateDom).
 */

import { toMap, log, timeout, getDataRepository, getWebPageService } from "../../../HA";
import { dispatchResponse } from "../Service/ResponseDispatcher";
import { Tag } from "./Tag";

export interface AnchorInteractiveHost {
    findById(id: string, deep?: boolean): Tag | null;
}

export class AnchorInteractiveHandler {
    constructor(private readonly host: AnchorInteractiveHost) {}

    public handle(data: any): void {
        getDataRepository().fetchData(data).then((response: Map<any, any>) => {
            this.dispatchAction(response);
        }).catch((reason: any) => {
            log(["fetch error", reason]);
        });
    }

    /**
     * Routage d'une réponse action générique (cf. legacy Anchor.processAction).
     * Aussi exposé pour le bulk : chaque étape est routée par la même logique.
     */
    public dispatchAction(data: Map<string, any>): void {
        const reloadFromD = (r: Map<any, any>) =>
            getWebPageService().reloadApp(toMap(r.get("d")));
        dispatchResponse(data, {
            handlers: {
                reload:  reloadFromD,
                success: reloadFromD,
                app:     reloadFromD,
                url: (r) => timeout(
                    () => window.open(r.get("url"), r.get("target")),
                    200,
                ),
                dom: (r) => this.updateDom(r),
                bulk:  (r) => this.processBulk(r.get("steps")),
                steps: (r) => this.processBulk(r.get("steps")),
            },
        });
    }

    private updateDom(data: Map<any, any>): void {
        if (data.get("doma") !== "repl") {
            return;
        }
        const t = this.host.findById(data.get("eid"), true);
        if (t) {
            t.clear();
            t.appendChild(new Tag(data.get("c")));
        }
    }

    private processBulk(steps: any[]): void {
        if (!Array.isArray(steps)) { return; }
        for (const item of steps) {
            this.dispatchAction(toMap(item) as Map<string, any>);
        }
    }
}
